import { createEvent } from "effector"

export const setSearch: any = createEvent()
